export default "__VITE_ASSET__8a8b7169__"